let head = document.head;
let config = { childList: true };
let callback = function(mutationsList, observer) {
    for (let i = 0; i < mutationsList.length; i++) {
        if (mutationsList[i].type) {
            let badCssLink = document.head.querySelector('link[href="//calculatorsonline.com.au/external/!main/stamp_duty.css"]');
            if (badCssLink) {
                badCssLink.parentNode.removeChild(badCssLink);
                let xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function() {
                    if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                        let stampDutyCalcStyle = document.createElement('style');
                        let styles = xhr.response;
                        styles = styles.replace('.row{width:100%', '#stamp-duty-calculator .row{width:100%');
                        styles = styles.replace(/max\-width:720px/g, 'max-width:768px');
                        styles = styles.replace(/max\-width:450px/g, 'max-width:576px');
                        styles = styles.replace(/stampduty\-webfont\./g, '//calculatorsonline.com.au/external/!main/stampduty-webfont.');
                        stampDutyCalcStyle.textContent = styles;
                        head.appendChild(stampDutyCalcStyle);

                        let calculateButtons = document.querySelectorAll('#stamp-duty-calculator input.stamp-calculate');
                        for (let i = 0; i < calculateButtons.length; i++) {
                            calculateButtons[i].value = 'Calculate';
                        }

                        document.querySelector('#stamp-duty-calculator').classList.remove('d-none');
                    }
                }
                xhr.open('GET', '//calculatorsonline.com.au/external/!main/stamp_duty.css');
                xhr.send();
                observer.disconnect();
            }
        }
    }
}
let observer = new MutationObserver(callback);
observer.observe(head, config);